import React from "react"
import Accordion from "react-bootstrap/Accordion"
import Card from "react-bootstrap/Card"
import questionsAndAnswers from "./questionsAndAnswers"
import uuid from "uuid"
import styles from "./FAQ.module.scss"

const AccordionGroup = props => {
  return (
    <Accordion defaultActiveKey="0" className="w-100">
      {questionsAndAnswers.map((qAndA, i) => {
        return (
          <Card key={uuid()} className={styles.card}>
            <Accordion.Toggle
              as={Card.Header}
              eventKey={i}
              className={styles.cardHeader}
              onClick={e => {
                if (e.currentTarget) {
                  e.currentTarget.classList.toggle("open")
                }
              }}
            >
              {typeof qAndA.q === "string" ? (
                <p
                  className={
                    styles.question + " proxima-nova--semi-bold fs-18pt"
                  }
                >
                  {qAndA.q}
                </p>
              ) : (
                qAndA.q
              )}
            </Accordion.Toggle>
            <Accordion.Collapse
              role="button"
              aria-label="toggle this accordion"
              eventKey={i}
            >
              <Card.Body className={styles.cardBody}>{qAndA.a}</Card.Body>
            </Accordion.Collapse>
          </Card>
        )
      })}
    </Accordion>
  )
}

export default AccordionGroup
